import { render, staticRenderFns } from "./CreateInvestorGoalWizardModal.vue?vue&type=template&id=782d9575&scoped=true&"
import script from "./CreateInvestorGoalWizardModal.vue?vue&type=script&lang=ts&"
export * from "./CreateInvestorGoalWizardModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateInvestorGoalWizardModal.vue?vue&type=style&index=0&id=782d9575&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782d9575",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VIcon,VRow})
